import React, {Component} from "react";

class PivotAreaVehicleMode extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);
        this.initState = {
            companyCode: "",
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        // console.log(this.props.dataPivot.group_area);
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.time !== prevProps.time) {
            // console.log(this.props.dataPivot.group_area);
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <div style={{overflowX: 'auto'}}>
                    <table style={{width: "100%"}}>
                        <thead>
                        <tr className={`fixed-table-row`} style={{borderBottom: "1px solid #d6d6d6"}}>
                            <td style={{height: "30px", textAlign: "center"}}>Model Kendaraan</td>
                            {Object.entries(this.props.dataPivot.group_area).map(([area, value]) => (
                                <td style={{height: "30px", textAlign: "center"}}>{area?.toLowerCase()?.replace(/\b\w/g, (s: string) => s?.toUpperCase())}</td>
                            ))}
                            <td style={{height: "30px", textAlign: "center"}}><b>Grand Total</b></td>
                        </tr>
                        </thead>
                        <tbody>
                        {Object.entries(this.props.dataPivot.group_vehicle_model).map(([model, value]) => (
                            <tr style={{borderBottom: "1px solid #d6d6d6"}}>
                                <td style={{height: "30px"}} key={model}>{model?.toLowerCase()?.replace(/\b\w/g, (s: string) => s?.toUpperCase())}</td>
                                {Object.entries(this.props.dataPivot.group_area).map(([area, value]) => (
                                    <td style={{height: "30px", textAlign: "center"}} key={area + model}>{this.props.dataPivot.area_model?.[area]?.[model]}</td>
                                ))}
                                <td style={{height: "30px", textAlign: "center"}}><b>{this.props.dataPivot.group_vehicle_model[model]}</b></td>
                            </tr>
                        ))}
                        <tr className={`fixed-table-row`} style={{borderBottom: "1px solid #d6d6d6"}}>
                            <td><b>Grand Total</b></td>
                            {Object.entries(this.props.dataPivot.group_area).map(([area, value]) => (
                                <td style={{height: "30px", textAlign: "center"}}><b>{this.props.dataPivot.group_area[area]}</b></td>
                            ))}
                            <td style={{height: "30px", textAlign: "center"}}><b>{this.props.totalDataOpen}</b></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </React.Fragment>
        );
    }
}

export default PivotAreaVehicleMode;